import styled from 'styled-components';
import devLogger from 'react-utils/devLogger';
import { LinkIcon } from 'foundations-assets';
import { stringToId } from 'developer-docs-shared-components/utils/urls';
import I18n from 'I18n';
import UIRouterLink from 'ui-addon-react-router-dom/UIRouterLink';
import { getQueryParam } from '../utils/urls';
import { CopyButton } from 'foundations-components/transitional/components/CopyButton';
import { Flex } from 'foundations-components/components/Flex';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const AnchorContainer = styled.span.withConfig({
  displayName: "MdxHeader__AnchorContainer",
  componentId: "sc-1k5gg6u-0"
})(["display:flex;justify-content:center;padding-left:4px;margin-bottom:-3px;button{opacity:0;transition:opacity 0.3s;&:hover,&:focus{opacity:1;}}"]);
const HeaderContainer = styled.div.withConfig({
  displayName: "MdxHeader__HeaderContainer",
  componentId: "sc-1k5gg6u-1"
})(["&:hover ", " button{opacity:1;}"], AnchorContainer);
function HeaderLink(props) {
  const {
    hash
  } = props;
  const url = `${window.location.origin}${window.location.pathname}#${hash}`;
  return /*#__PURE__*/_jsx(AnchorContainer, {
    children: /*#__PURE__*/_jsx(CopyButton, {
      use: "unstyled",
      value: url,
      hint: I18n.text('developer-docs-shared-components.tooltips.copyAnchorLink'),
      children: /*#__PURE__*/_jsx(LinkIcon, {
        color: "do-not-use-battleship",
        size: "600"
      })
    })
  });
}
function MdxHeader(props) {
  const {
    children,
    Component,
    marginBlockStart,
    marginBlockEnd
  } = props;
  const uuid = getQueryParam('uuid');
  if (typeof children === 'string') {
    const id = stringToId(children);
    return /*#__PURE__*/_jsx(HeaderContainer, {
      children: /*#__PURE__*/_jsxs(Flex, {
        alignItems: "center",
        marginBlockStart: marginBlockStart,
        marginBlockEnd: marginBlockEnd,
        children: [/*#__PURE__*/_jsx(Component, {
          id: id,
          children: /*#__PURE__*/_jsx(UIRouterLink, {
            use: "unstyled",
            to: `#${id}${uuid ? `?uuid=${uuid}` : ''}`,
            children: children
          })
        }), /*#__PURE__*/_jsx(HeaderLink, {
          hash: id
        })]
      })
    });
  }

  // TODO Do we need to support non string cases?
  devLogger.warn({
    message: 'Unexpected MdxHeader child type:',
    key: null
  });
  devLogger.warn({
    message: children,
    key: null
  });
  return /*#__PURE__*/_jsx(Component, {
    children: children
  });
}
export default MdxHeader;